import React, { useEffect, useState } from 'react';
import { fetchOrders } from '../api/airtable';
import OrderList from './OrderList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons';

const CompletedOrders = ({ userRole, carNumber, username, pageTitle }) => {
    const [completedOrders, setCompletedOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getCompletedOrders = async () => {
            setIsLoading(true);
            let allOrders = await fetchOrders();
            const unwantedStatuses = ["จ่ายแล้ว ส่งแล้ว", "โอนแล้ว ส่งแล้ว", "ไม่ส่ง", "ไม่รับ", "ไม่ตอบ", "ไม่รับเลื่อนส่ง"];
            
            const now = new Date();
            const currentHours = now.getHours();
            let targetDate = now.toLocaleDateString("th-TH");

            if (currentHours >= 0 && currentHours < 4) {
                const yesterday = new Date();
                yesterday.setDate(now.getDate() - 1);
                targetDate = yesterday.toLocaleDateString("th-TH");
            }
            const filteredOrders = allOrders
                .filter(order => {
                    const orderDate = new Date(order.fields['กำหนดส่ง']).toLocaleDateString("th-TH");
                    const isCarMatched = order.fields['เบอร์รถ'] && order.fields['เบอร์รถ'].trim() === String(carNumber).trim();
                    return unwantedStatuses.includes(order.fields['สถานะ']) && isCarMatched && orderDate === targetDate;
                })
                .sort((a, b) => (b.fields['ลำดับส่ง'] || 0) - (a.fields['ลำดับส่ง'] || 0)); // เรียงจากมากไปน้อย

            setCompletedOrders(filteredOrders);
            setIsLoading(false);
        };

        getCompletedOrders();
    }, [carNumber]);

    return (
        <div>
            <header className="page-header">
                <h1>{`${pageTitle} รถเบอร์ ${carNumber}`}
                    <span className='count'>{' '}{completedOrders.length}</span>
                </h1>
            </header>

            <div className="completed-orders-container orders-container">
                {isLoading ? (
                    <div className="load-orders-message-container">
                        <FontAwesomeIcon icon={faClipboardCheck} className="load-orders-icon load-orders-paper" />
                        <p className="load-orders-message">โหลดงานที่เสร็จแล้ว...</p>
                    </div>
                ) : (
                    <OrderList
                        orders={completedOrders}
                        username={username}
                        onOrderUpdate={(orderId) => setCompletedOrders(completedOrders.filter(order => order.id !== orderId))}
                        shouldRemoveOnUpdate={false}
                    />
                )}
            </div>
        </div>
    );
};

export default CompletedOrders;
